import { withStyles } from '@material-ui/core/styles';
import { useParams } from 'react-router-dom';
import React, { useState, useEffect } from 'react';
import { getAutomationLogById } from '../../services/automations.service';
import { 
  CircularProgress, 
  Paper, 
  Typography, 
  Grid, 
  Box,
  Divider 
} from '@material-ui/core';
import ErrorMessage from '../../components/Error/ErrorMessage';
import classnames from 'classnames';

const styles = theme => ({
  paper: {
    padding: theme.spacing(3),
    margin: theme.spacing(2, 0),
    boxSizing: 'border-box'
  },
  header: {
    marginBottom: theme.spacing(2)
  },
  detailItem: {
    marginBottom: theme.spacing(2)
  },
  label: {
    fontWeight: 'bold',
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(1)
  },
  value: {
    wordBreak: 'break-word'
  }
});

const AutomationLogsDetail = withStyles(styles)(({ classes }) => {
  const { automationLogId } = useParams();
  const [automationLog, setAutomationLog] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);

  
  const fetchAutomationLogById = async () => {
    try {
      const automationLog = await getAutomationLogById(automationLogId);
    setAutomationLog(automationLog);
    setIsLoading(false);
  } catch (error) {
    setIsError(true);
    setIsLoading(false);
  }
  };


  useEffect(() => {
    fetchAutomationLogById();
  }, []);


  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    try {
      return new Date(dateString).toLocaleString();
    } catch (error) {
      return dateString;
    }
  };

  if (isLoading) {
    return <CircularProgress />;
  }
  if (isError) {
    return <ErrorMessage message="There was an error fetching automation logs." />;
  }

  return (
    <div className={classnames('grid-container')}>
      <Paper className={classes.paper} elevation={2}>
        <Box className={classes.header}>
          <Typography variant="h5" component="h1" gutterBottom>
              Log Details
          </Typography>
          <Divider />
        </Box>

        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Box className={classes.detailItem}>
              <Typography variant="subtitle2" className={classes.label}>
                Log Level
              </Typography>
              <Typography variant="body1" className={classes.value}>
                {automationLog.logLevel || 'Unknown'}
              </Typography>
            </Box>
          </Grid>

          <Grid item xs={12}>
            <Box className={classes.detailItem}>
              <Typography variant="subtitle2" className={classes.label}>
                Log Date
              </Typography>
              <Typography variant="body1" className={classes.value}>
                {formatDate(automationLog.logDate)}
              </Typography>
            </Box>
          </Grid>

          <Grid item xs={12}>
            <Box className={classes.detailItem}>
              <Typography variant="subtitle2" className={classes.label}>
                Message
              </Typography>
              <Paper 
                variant="outlined" 
                style={{ 
                  padding: '16px', 
                  backgroundColor: '#f5f5f5',
                  marginTop: '8px'
                }}
              >
                <Typography variant="body1" className={classes.value}>
                  {automationLog.message || 'No message available'}
                </Typography>
              </Paper>
            </Box>
          </Grid>
        </Grid>
      </Paper>
    </div>
  );
});

export { AutomationLogsDetail };